import React, { useState } from 'react'
import { StatBoxes, StatTables } from './LeaderboardPageComponents'
import { YourStatsSectionContainer } from './LeaderboardPageStyles'
import { apiURL, commonHeadersWeb } from 'src/consumer/services';
import axios from 'axios';
import { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';

export default function YourStats(props) {

    const [userStats, setUserStats] = useState(null);
    const token = localStorage.getItem('token');

    const getStats = async () => {
        try {
            const response = await axios.get(`${apiURL}/api/secure/user/stats`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    ...commonHeadersWeb,
                    'ef-user-country-code': localStorage.getItem('countryCode'),
                    'ef-app-language': sessionStorage.getItem('languageCode')
                }
            });
            setUserStats(response?.data)
            return response;
        } catch (error) {
            console.log(error)
            return (error);
        }
    }

    useEffect(() => {
        getStats();
    }, [])

    return (
        <>
            {(Boolean(userStats)) ?
                <YourStatsSectionContainer>
                    <StatBoxes data={userStats} />
                    <StatTables data={userStats} />
                </YourStatsSectionContainer> :
                <Spinner animation="border" variant="light" size="md" />
            }
        </>
    )
}
